import React, { useEffect, useCallback } from 'react';

import { DynamicFormField } from '../../ui/form'

import { getB3OrderExtras, getDefaultB3OrderExtrasVal } from './order'

const OrderExtras = (props: any) => {

  const { setFieldValue } = props


  useEffect(() => {
    const extrasFiles = getDefaultB3OrderExtrasVal()
    if (extrasFiles) {
      Object.keys(extrasFiles).forEach((item: any) => {
        setFieldValue(`customFields.${item}`, extrasFiles[item] || '')
      })
    }
  }, [])

  const B3PaymentExtras = getB3OrderExtras()

  return(
    <div className="orderExtrasContainer">
      { B3PaymentExtras.map((field: any) => {
            const paymentFieldName = field.name

            const basicFiledProps = {
                autocomplete: field.name,
                extraClass: `dynamic-form-field--${paymentFieldName}`,
                field: field,
                inputId: paymentFieldName,
                // stateOrProvince can sometimes be a dropdown or input, so relying on id is not sufficient
                key: `${field.id}-${field.name}`,
                label: field.label,
                onChange: useCallback(() => {}, []),
                parentFieldName: 'customFields',
                placeholder: '',
            }

            if (!field.visibleToEnduser) return null

            return (
                <DynamicFormField
                    { ...basicFiledProps }
                />
            )
        }) }
    </div>
  )
}

export default OrderExtras 